import React from 'react';
import { CHART_SERIES_COLORS } from './palette';
/** Tiny inline trend line for table rows — pure SVG, no chart lib. */
export const Sparkline = ({ values, width = 96, height = 28, color = CHART_SERIES_COLORS[0], label, }) => {
    if (!values.length || values.every((v) => !Number.isFinite(v) || v === 0)) {
        return React.createElement("span", { className: "text-xs text-gray-300" }, "\u2014");
    }
    const pad = 2;
    const max = Math.max(...values);
    const min = Math.min(...values, 0);
    const span = max - min || 1;
    const stepX = values.length > 1 ? (width - pad * 2) / (values.length - 1) : 0;
    const points = values
        .map((v, i) => {
        const x = pad + i * stepX;
        const y = height - pad - ((v - min) / span) * (height - pad * 2);
        return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
        .join(' ');
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, role: "img", "aria-label": label || 'Trend', className: "overflow-visible" },
        React.createElement("polyline", { points: points, fill: "none", stroke: color, strokeWidth: 2, strokeLinejoin: "round", strokeLinecap: "round" })));
};
export default Sparkline;
